import { Button } from '@material-ui/core';
import React from 'react';

import { useDialogState } from './useDialogState';

export const CancelButton = (): React.ReactElement => {
  const [, setDialogState] = useDialogState();

  const handleClose = (): void => {
    setDialogState(null);
  };

  return (
    <Button variant="contained" onClick={handleClose}>
      Cancel
    </Button>
  );
};
